
import {
    captionTitle,
    cellInner,
    copyButtonWrapper,
    surveySummaryTableStyles,
} from 'components/AudienceMetadata/styles/SurveySummaryTable'

export const styledPrescriptionRenewalSurveyResultsView = {
    ...surveySummaryTableStyles,
    '& table': {
        ...surveySummaryTableStyles['& table'],
        '& tr': {
            ...surveySummaryTableStyles['& table']['& tr'],
            '& td': {
                ...surveySummaryTableStyles['& table']['& tr']['& td'],
                paddingTop: '0.5rem',
            },
        },
    },
}

export {
    captionTitle,
    cellInner,
    copyButtonWrapper,
}

